export default {
  title: {
    id: 'asp_agent_action_bar_refund_step_title',
    defaultMessage: 'Refund item',
  },
  inputAmount: {
    id: 'asp_agent_action_bar_refund_step_input_amount',
    defaultMessage: 'Refund amount (shipping costs included)',
  },
  refundButton: {
    id: 'asp_agent_action_bar_refund_step_refund_cta',
    defaultMessage: 'Refund',
  },
  shouldBeGreaterThan: {
    id: 'asp_agent_action_bar_refund_step_refund_amount_greater_than_expected',
    defaultMessage: 'Refund amount should be more than {minRefundablePrice}',
  },
  shouldBeLowerThan: {
    id: 'asp_agent_action_bar_refund_step_refund_amount_lower_than_expected',
    defaultMessage: 'Refund amount should be less than {maxRefundablePrice}',
  },
  isRequired: {
    id: 'asp_agent_action_bar_refund_step_field_required',
    defaultMessage: 'This field is required.',
  },
  errorToastTitle: {
    id: 'asp_agent_action_bar_refund_step_error_toast_title',
    defaultMessage: "Hmm, that didn't work.",
  },
  errorToastLabel: {
    id: 'asp_agent_action_bar_refund_step_error_toast_label',
    defaultMessage: 'Please try again.',
  },
}
